var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Avatar from '@mui/material/Avatar';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns';
import { SpeechBubble } from '../SpeechBubble';
const AvatarStyled = styled(Avatar, {
    shouldForwardProp: (prop) => !['highlighted'].includes(prop)
}) `
    margin-top: 4px;
    margin-right: 10px;
    border: 2px solid
        ${(props) => (props.highlighted ? props.theme.palette.primary.main : props.theme.palette.text.secondary)};
    width: 32px;
    height: 32px;
`;
const Root = styled('div') `
    padding: 4px;
    margin-bottom: 12px;
`;
const MessageHeader = styled('div') `
    display: flex;
`;
const MessageAuthor = styled(Typography) `
    font-weight: 700;
    font-size: 14px;
`;
const Timestamp = styled(Link) `
    margin-left: auto;
    font-size: 14px;
`;
const MessageContent = styled('div') `
    display: flex;
`;
export const ChatMessage = (props) => {
    const { avatarSrc, author, message, timestampMs, highlighted = false, onTimestampClick } = props, other = __rest(props, ["avatarSrc", "author", "message", "timestampMs", "highlighted", "onTimestampClick"]);
    return (_jsxs(Root, Object.assign({}, other, { children: [_jsxs(MessageHeader, { children: [_jsx(MessageAuthor, { variant: 'subtitle1', children: author }), _jsx(Timestamp, { component: 'button', onClick: onTimestampClick, children: format(timestampMs, 'p') })] }), _jsxs(MessageContent, { children: [_jsx(AvatarStyled, { highlighted: highlighted, src: avatarSrc }), _jsx(SpeechBubble, { highlighted: highlighted, variant: 'body2', children: message })] })] })));
};
